import { translate } from '@/utils/translations'

// Payment authorization and fulfillment can outrun the shared http client's
// 15s default, which would cut the request off and show the user an incomplete
// or wrong response. Covers the Stripe card, Stripe wallet, and financial aid
// calls in reducers/checkout/asyncActions, plus PayPal execute. PayPal
// create/authorize post through the PayPal SDK's own request layer rather than
// this client, so they are not covered here.
export const CHECKOUT_API_TIMEOUT_MS = 120000

export const PROMO_CODE_ERRORS = {
  cartIneligibleError: 'cart_ineligible_error',
  cartMinimumError: 'cart_minimum_error'
}

export const PAYMENT_TYPES = {
  applepay: 'apple_pay',
  paypal: 'paypal',
  stripe: 'stripe',
  watchman: 'watchman'
}

export const PAYMENT_REQUEST_LABEL = 'VitalSource'

export const CREDIT_CARD_PAYMENT_TYPES = [
  PAYMENT_TYPES.stripe
]

export const FORM_STEPS = {
  billingAddress: 'billingAddress',
  choosePayment: 'choosePayment',
  creditCardPayment: 'creditCardPayment',
  editBillingAddressStep: 'editBillingAddressStep',
  financialAidConfirmPurchase: 'financialAidConfirmPurchase',
  institutionPicker: 'institutionPicker',
  institutionPickerEdit: 'institutionPickerEdit',
  paypalConfirmPurchase: 'paypalConfirmPurchase',
  savedPaymentPreview: 'savedPaymentPreview'
}

export const STRIPE_STATES = {
  authorizedPayment: 'authorizedPayment',
  createdPaymentMethod: 'createdPaymentMethod',
  handledCardAction: 'handledCardAction',
  handlingCardAction: 'handlingCardAction',
  initial: 'initial',
  processing: 'processing'
}

export const GENERIC_ERROR = {
  message: translate('errors.unexpected_error')
}
